import React from "react";
import { Formik, FormikProps } from "formik";
import * as Yup from "yup";
import { Values } from "Tools/Values";
import renderCommonFormField from "@src/Components/Common/FormFields/renderCommonFormField";
import { observer, inject } from "mobx-react";
import { STFormTitleTypography } from "@src/Components/Ui/STFormTitleTypohraphy";
import _ from "lodash";
import { STFormWrapper } from "./styles";
import { Grid, Tooltip } from "@material-ui/core";
import { STButtonMargin } from "@src/Components/Ui/STButtonMargin";
import { Done, Clear } from "@material-ui/icons";import { STContentWrapper } from "@src/Components/Common/SimpleModal/styles";
import { IAuthStore } from "@src/Stores/Auth/types";
import { IUserApiTokenInfo } from "@src/Interfaces/Entity/UserApiToken";

const oAuthSchema = () =>
  Yup.object().shape({
    name: Yup.string().required(() => {
      return Values.getLocalizationValue("fieldRequired");
    })
  });

interface IProps {
  title: string;
  initialValues: IUserApiTokenInfo;
  onSubmit: (values: IUserApiTokenInfo) => void;
  onClose: () => void;
  infoWindow: boolean;
  auth?: IAuthStore;
}

@inject("auth")
@observer
class AuthApiTokenForm extends React.Component<IProps> {
  render() {
    return (
      <Formik
        enableReinitialize
        initialValues={this.props.initialValues}
        validationSchema={() => oAuthSchema()}
        onSubmit={this.props.onSubmit}
        render={(formikProps: FormikProps<IUserApiTokenInfo>) => (
          <STFormWrapper onSubmit={formikProps.handleSubmit}>
            <STFormTitleTypography>{this.props.title}</STFormTitleTypography>
            <STContentWrapper>
              {renderCommonFormField<IUserApiTokenInfo>(
                "name",
                "name",
                formikProps,
                !this.props.infoWindow
              )}
            </STContentWrapper>
            <Grid container justify="center" style={{ marginTop: "12px" }}>
              {!this.props.infoWindow && (
                <STButtonMargin onClick={formikProps.handleSubmit} variant="contained" color="primary">
                  <Done />
                </STButtonMargin>
              )}
              <STButtonMargin onClick={this.props.onClose} variant="contained">
                <Clear />
              </STButtonMargin>
            </Grid>
          </STFormWrapper>
        )}
      />
    );
  }
}

export default AuthApiTokenForm;
